import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Facebook, Instagram, YouTube, Twitter } from '@mui/icons-material';

// A custom SVG icon for TikTok
const TikTokIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2859 3333" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" {...props}>
    <path d="M2081 0c55 473 319 755 778 785v532c-266 26-499-61-770-225v995c0 1264-1378 1659-1782 606-345-874 16-1164 1468-1402v-548c-911-201-1263 215-1263 885 0 362 232 711 553 870 263 132 563 133 849-16v532c-262 22-553 35-824-50-1018-313-1425-1333-1425-2333 0-1225 1083-2142 2262-2142 172 0 344 13 512 39V0z"/>
  </svg>
);

const socialLinks = [
  { name: 'Facebook', icon: <Facebook />, url: 'https://www.facebook.com/marathonRuns/' },
  { name: 'Instagram', icon: <Instagram />, url: 'https://www.instagram.com/marathonruns/' },
  { name: 'YouTube', icon: <YouTube />, url: 'https://www.youtube.com/marathonruns/' },
  { name: 'Twitter', icon: <Twitter />, url: 'https://www.twitter.com/marathonruns/' },
  { name: 'TikTok', icon: <TikTokIcon sx={{ fontSize: 24 }} />, url: 'https://www.tiktok.com/@marathonruns' },
];

const SocialMediaBar = () => {
  return (
    <Box sx={{ textAlign: 'center', py: 1 }}>
      {socialLinks.map((social) => (
        <Tooltip title={social.name} key={social.name}>
          <IconButton
            component="a"
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
          >
            {social.icon}
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
};

export default SocialMediaBar;
